module.exports = __webpack_public_path__ + "static/media/PMP.89312256.svg";